<template>
  <v-menu
    v-model="menu_ativo"
    open-on-hover bottom
    offset-y
    :close-on-content-click="false"
    :open-delay="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-on="on"
        v-bind="attrs"
        class="text-white font-14"
        :title="fornecedor.title.toUpperCase()"
        v-text="fornecedor.text.toUpperCase()"
        @click="routerPushGrupo()"
      />
    </template>

    <div v-if="analiseGrupoFornecedores" class="bg-white pt-2 pl-2" style="width: 350px">
      <p class="ma-0 my-2 font-14 font-weight-medium">
        <v-icon left small>mdi-format-list-bulleted</v-icon>
        Fornecedores
      </p>

      <ListaFornecedoresDoGrupoAnalise
        :id_grupo_analise="fornecedorCompra.id"
        :height="300"
      />
    </div>
  </v-menu>
</template>

<script>
import ListaFornecedoresDoGrupoAnalise from "../../dashboard/fornecedor/ListaFornecedoresDoGrupoAnalise";
import {mapGetters} from "vuex";

export default {
  name: "NomeFornecedorMenu",
  components: {ListaFornecedoresDoGrupoAnalise},
  props: {
    fornecedor: Object
  },
  data: () => ({
    menu_ativo: false
  }),
  computed: {
    ...mapGetters({
      fornecedorCompra: "fornecedor/getFornecedor",
    }),
    analiseGrupoFornecedores() {
      return localStorage.analiseGrupoFornecedores === 'S';
    }
  },
  methods: {
    routerPushGrupo() {
      this.$emit("push-dashboard", this.fornecedor.rota);
    }
  }
}
</script>

<style scoped>

</style>
